import type { ILogger } from '@cian/logger';

/** «Добавить здание в каталог БЦ» / «Стать официальным представителем» */
export type TRepresentativeRequestType = 'addBuilding' | 'becomeRepresentative';

/** Данные заявки из формы */
export interface IRepresentativeRequestData {
  requestType: TRepresentativeRequestType;
  name: string;
  /** Только цифры, с кодом страны: `79161234567` */
  phone: string;
  email: string | null;
  buildingName: string | null;
  /** Только для «Стать официальным представителем» */
  comment: string | null;
}

export interface ICreateRepresentativeRequestParams extends IRepresentativeRequestData {
  logger: ILogger;
  buildingId: number;
}

/**
 * Заявка «Стать официальным представителем». В монолите — `/ajax/feedback/` (`source=bsc_request`, письмо
 * на `cre@cian.ru`); для карточки бэкенд делает ручку в `commercial-buildings`, до неё отправка не работает:
 * пишем в лог и отклоняем, чтобы форма не показала ложный успех
 */
export async function createRepresentativeRequest(params: ICreateRepresentativeRequestParams): Promise<void> {
  const { logger, buildingId, requestType } = params;

  logger.warning('Заявка официального представителя ещё не подключена к API', {
    domain: 'services/createRepresentativeRequest',
    buildingId,
    requestType,
  });

  throw new Error('Заявка официального представителя ещё не подключена к API');
}
